"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var tooltip_1 = require("../tooltip");
var config_context_1 = require("../_util/config-context");
var copy_1 = require("../copy");
function TextRaw(props, ref) {
    var _a;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var parent = props.parent, align = props.align, verticalAlign = props.verticalAlign, overflow = props.overflow, nowrap = props.nowrap, underline = props.underline, tooltip = props.tooltip, className = props.className, style = props.style, theme = props.theme, bgTheme = props.bgTheme, float = props.float, reset = props.reset, copyable = props.copyable, htmlProps = tslib_1.__rest(props, ["parent", "align", "verticalAlign", "overflow", "nowrap", "underline", "tooltip", "className", "style", "theme", "bgTheme", "float", "reset", "copyable"]);
    var rawChildren = props.children;
    var children = rawChildren;
    if (copyable && !overflow) {
        var copyProps = typeof copyable === "object" ? copyable : {};
        children = (react_1.default.createElement(react_1.default.Fragment, null,
            children,
            " ",
            react_1.default.createElement(copy_1.Copy, tslib_1.__assign({ text: children }, copyProps))));
    }
    var element = react_1.default.createElement(parent || "span", tslib_1.__assign({ ref: ref, className: classnames_1.default(className, (_a = {},
            _a[classPrefix + "-bg-" + bgTheme] = bgTheme,
            _a[classPrefix + "-text"] = theme === "text",
            _a[classPrefix + "-text-" + theme] = theme && theme !== "text",
            _a[classPrefix + "-text-" + align] = align,
            _a[classPrefix + "-align-" + verticalAlign] = verticalAlign,
            _a[classPrefix + "-text-overflow"] = overflow,
            _a[classPrefix + "-text-nowrap"] = nowrap,
            _a[classPrefix + "-text-underline"] = underline,
            _a[classPrefix + "-float-" + float] = float && float !== "clear",
            _a[classPrefix + "-fz-reset"] = reset,
            _a["clearfix"] = float === "clear",
            _a)), style: style }, htmlProps), children);
    if (copyable && overflow) {
        var copyProps = typeof copyable === "object" ? copyable : {};
        element = react_1.default.createElement(parent || "span", {
            style: { display: "flex" },
        }, react_1.default.createElement(react_1.default.Fragment, null,
            element,
            react_1.default.createElement("span", { style: { flexShrink: 0 } },
                react_1.default.createElement(copy_1.Copy, tslib_1.__assign({ text: children }, copyProps)))));
    }
    // 提供快捷 tooltip 使用方式
    if (tooltip) {
        var title = typeof tooltip === "boolean" ? rawChildren : tooltip;
        element = react_1.default.createElement(tooltip_1.Tooltip, { title: title }, element);
    }
    return element;
}
exports.Text = react_1.forwardRef(TextRaw);
exports.Text.displayName = "Text";
//# sourceMappingURL=Text.js.map